import Component from '../core/Component'

const API_KEY = "AIzaSyBsmvDzj-rc_G_rJ2VPoU6C-0gTvEnhhKw";
const LOCATION = {
   lat: 50.09210492562565,
   lng: 14.453035698898017
};

export default class GoogleMap extends Component {

   constructor(element) {
      super(element)
   }

   prepare() {
      this.loadScript();
      this.googleMapsPromise.then((google) => {
         this.initMap(google)
      });

   }

   loadScript() {
      if (!this.googleMapsPromise) {
         this.googleMapsPromise = new Promise((resolve) => {

            window.resolveGoogleMapsPromise = () => {
               resolve(google);
               delete window.resolveGoogleMapsPromise;
            };

            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=resolveGoogleMapsPromise`;
            script.async = true;
            document.body.appendChild(script);
         });
      }

      // Return a promise for the Google Maps API
      return this.googleMapsPromise;
   }

   initMap(google) {
      const map = new google.maps.Map(this.element, {
         zoom: 15,
         center: LOCATION,
         scrollwheel: false,
         disableDefaultUI: true,
         navigationControl: false,
         mapTypeControl: true,
         scaleControl: true,
         draggable: true,
         styles: [{
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [{
               "saturation": -100
            }]
         }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [{
               "visibility": "off"
            }]
         }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
               "saturation": -100
            }, {
               "lightness": 45
            }, {
               "visibility": "on"
            }]
         }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
               "saturation": -100
            }, {
               "lightness": 50
            }, {
               "visibility": "simplified"
            }]
         }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
               "saturation": -100
            }]
         }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
               "visibility": "simplified"
            }]
         }, {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [{
               "lightness": 30
            }]
         }, {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [{
               "lightness": 40
            }]
         }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
               "saturation": -100
            }, {
               "visibility": "simplified"
            }]
         }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
               "hue": "#ffff00"
            }, {
               "lightness": -25
            }, {
               "saturation": -97
            }]
         }, {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [{
               "lightness": -25
            }, {
               "saturation": -100
            }]
         }]
      });


      const marker = new google.maps.Marker({
         position: LOCATION,
         map: map,
         draggable: false,
         title: "Foxentry",
         icon: "/assets/img/components/map-section/map-marker.png"
      });
   }

}